import classNames from 'classnames';
import { ComponentProps, createContext, useContext } from 'react';
import { MdLock } from 'react-icons/md';
import { Link, LinkProps } from 'react-router-dom';
import NavBarBadge, { NavBarBadgeProps } from '../NavBarBadge/NavBarBadge';
import styles from './NavBarMenuContentItem.module.scss';

const NavBarMenuItemContext = createContext({ isDisabled: false });

const NavBarMenuItemBadge = ({ skin, className, ...props }: NavBarBadgeProps) => {
  const { isDisabled } = useContext(NavBarMenuItemContext);
  return <NavBarBadge className={classNames(styles['badge'], className)} skin={isDisabled ? 'grey' : skin} {...props} />;
};

const NavBarMenuContentItemLabel = ({ className, ...props }: ComponentProps<'span'>) => <span {...props} />;

type NavBarMenuContentItemProps = LinkProps & {
  isDisabled?: boolean;
};

const NavBarMenuContentItem = ({ to, children, className, isDisabled = false }: NavBarMenuContentItemProps) => {
  return (
    <NavBarMenuItemContext.Provider value={{ isDisabled }}>
      <Link to={to} className={classNames(styles['wrapper'], isDisabled && styles['wrapper-disabled'], className)}>
        {children}
        {isDisabled && <MdLock className={styles['lock-icon']} color="#959595" size={16} />}
      </Link>
    </NavBarMenuItemContext.Provider>
  );
};

export default {
  Root: NavBarMenuContentItem,
  Badge: NavBarMenuItemBadge,
  Label: NavBarMenuContentItemLabel,
};
